import jwt_decode from 'jwt-decode';
import { Role } from "@/utils/enums";

/**
 * Checks if the token is valid.
 *
 * @param token String
 */
export const isTokenValid = (token: string): boolean => {
  const tokenData: { exp: number } = jwt_decode(token);

  // TODO: upgrade to TS 3.7 for optional chaining.
  if (tokenData == null) return false;

  return tokenData.exp * 1000 > new Date().getTime();
};

export const getUserData = (token: string) => {
  const tokenData: { name: string, oid: string, groups: string[] } = jwt_decode(token);
  const groupNames = convertGroupIdsToGroupNames(tokenData.groups);
  return {
    username: tokenData.name,
    azureActiveDirectoryId: tokenData.oid,
    groups: groupNames,
    oid: tokenData.oid
  };
};

/**
 * Convert the group id's to group names to work with.
 */
const convertGroupIdsToGroupNames = (groupIds: string[]): string[] => {
  return groupIds.map(groupId => {
    return mapGroupIdToGroupName(groupId);
  }).filter(group => group !== '');
};

/**
 * Mapping with the ID of a group and the actual of the group.
 * The ID's can be found in the Azure AD of Stichting Bestaanskracht.
 */
const mapGroupIdToGroupName = (groupId: string): string => {
  switch (groupId) {
    case 'b208b267-bb5c-4fc2-bde7-ef4b1053f87f': return Role.ZORG_PROFESSIONAL;
    case '5923b9a7-8b67-4217-9f98-24505df65ff7': return Role.MELDKAMER_MEDEWERKER;
    case '056f25a6-3c3e-44ce-8ad0-90a3e333d527' : return Role.APP_ADMIN;
    case 'ac9875a9-2cea-40c8-ae2b-d177fd8bafde' : return Role.MILES_BEHEERDER;
    default: return '';
  }
};
